import { NativeBaseProvider as BaseNativeBaseProvider } from 'native-base';
import React, { ReactNode } from 'react';
import { theme } from '../../styles/theme';
import { NativeBaseSetup } from './NativeBaseSetup';

export const NativeBaseProvider = ({ children }: { children: ReactNode }): JSX.Element => {
  return (
    <BaseNativeBaseProvider theme={theme}>
      <NativeBaseSetup />

      {children}
    </BaseNativeBaseProvider>
  );
};
